import request from '@/config';
import { DictionarySearch, DictionaryList, DictionaryInfo } from './dictionary.type';

enum Apis {
	DictionaryCacheMap = `/api/dictionarygroup/getdictionarybycache`,
}

/* 获取字典值Map数据(缓存) */
export const GetDictionaryCacheMapApi = (): Promise<IResponse> => request.post({ url: Apis.DictionaryCacheMap, data: {} });

/* 数据字典：查询(LIST) */
export const getDictionaryList = (searchIpt: DictionarySearch): Promise<IResponse> => {
	return request.post({ url: '/api/PubDictionary/GetPubDictionaryPage', data: searchIpt });
};

/* 数据字典：详细 */
export const getDictionaryInfo = (dicID: string): Promise<IResponse<DictionaryInfo>> => {
	const scParams = { curr_user_id: null, tenant_id: 1, created_user_id: null, id: dicID };
	return request.post({ url: '/api/PubDictionary/GetPubDictionaryInfo', data: scParams });
};

/* 数据字典：删除 */
export const delDictionary = (dicID: string): Promise<IResponse> => {
	const delParams = { revision: '0', deleted_user_id: '1', tenant_id: 1, id: dicID };
	return request.post({ url: '/api/PubDictionary/DeletePubDictionary', data: delParams });
};

// /* 创建数据字典 */
// export const creationDic = (creatDto: DictionaryCreate = { code: 'e8fed4d9141b1e0f', tenant_id: 1 }): Promise<IResponse<string>> => {
//     return request.post({ url: '/api/PubDictionary/InsertPubDictionary', creatDto })
// }
